import React,{ useState } from "react";
import { Create,SimpleForm,TextInput, DateInput, BooleanInput } from "react-admin";
import { Button, Box } from '@mui/material';
import { useSelector } from "react-redux";
import { redirect } from "react-router";
import { useNotify, useRedirect } from 'react-admin';
import ImageSelectorModal from "../imageSelectorModal";

const REACT_APP_URL_API= process.env.REACT_APP_URL_API;

// const REACT_APP_SERVER_API= process.env.REACT_APP_SERVER_API;
// const REACT_APP_PORT_API = process.env.REACT_APP_PORT_API;
// const REACT_APP_PATH_API = process.env.REACT_APP_PATH_API;
// const REACT_APP_PATH_API_NEWS = process.env.REACT_APP_PATH_API_NEWS;

// const BASE_NEWS_URL = `${REACT_APP_SERVER_API}:${REACT_APP_PORT_API}/${REACT_APP_PATH_API}/${REACT_APP_PATH_API_NEWS}`;


export const  NewsCreate = (props)=>{
    const [imageUrl,setImageUrl]= useState('');
    const [modalOpen,setModalOpen]= useState(false)
    const notify = useNotify();
    const redirect = useRedirect();    
    const credentials =  useSelector(state=> state.credentials);
    const token = credentials.token || localStorage.getItem('token') || null;

    const handleSubmit= async (values) =>{
        try {
            const payload = { ...values, image:imageUrl};
            const response = await fetch(`${REACT_APP_URL_API}/news/newAdd`,{
                 method:'POST',
                 headers: {'Content-Type': 'application/json', 'Authorization' : `Bearer ${token}` },
                 credentials:'include',
                 body:JSON.stringify(payload)
            });

            const result= await response.json();
            console.log('Response:', result); 

            if(response.ok){
                notify('Noticia creada con exito');
                redirect('/admin/news');
            }else{
                notify(result.message || 'Error al crear la noticia', {type:'error'});
            }        
        } catch (error) {
            console.log(error);
            notify('error en la red',{type: 'error'});
            
        }
    };

    return(
        <> 
    <Create {...props}>
        <SimpleForm onSubmit={handleSubmit}>
            <TextInput source="title" label="Título" fullWidth />
            <TextInput source="content" label="Contenido" multiline fullWidth />
            <Box mt={2}>
                <Button variant="contained" onClick={()=>setModalOpen(true)}>
                    Seleccionar Imagen
                </Button>
                {imageUrl &&(
                    <Box mt={1}>
                        <img src={imageUrl} alt="Seleccionada" width="200"/>
                    </Box>
                )}                
            </Box>
            
            <Box>
                <DateInput
                source="date" 
                label="Fecha de publicacion" 
                fullWidth={false}
                sx={{flex:1}}
                />
            </Box>
            
            
        </SimpleForm>
    </Create>
    <ImageSelectorModal
    open={modalOpen}
    onClose={()=>setModalOpen(false)}
    onSelect={(url)=>setImageUrl(url)}
    />
    </>
    )
}